import { send } from 'server';

export const getGameHistory = ({
    startDatetime,
    endDatetime,
    max,
    fields,
    consolidateBonusRounds,
    playerUsername,
    page,
    product,
    gamesSource
}) => send({
    ID: 35702,
    description: 'Get Game History',
    responses: [35703, 35704],
    startDatetime,
    endDatetime,
    max,
    fields,
    consolidateBonusRounds,
    filterOutParameters: ['EXITGAME'],
    playerUsername,
    page,
    product,
    gamesSource
});
